import axios from "axios";
import { keycloak } from "../../../lib/keycloak";
import { CustomerCreationDTO, CustomerResponseDTO, CustomerUpdateDTO, FindAllCustomerByCodeResponseDTO, FindAllCustomersFilters, findAllCustomersResponseDTO } from "./dto";
import { CustomerService } from "./service";

export class CustomerServiceImpl implements CustomerService {
    public createCustomer(data: CustomerCreationDTO): Promise<number> {
        return axios.post("/api/customer-data",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public updateCustomer(id: string, data: CustomerUpdateDTO): Promise<void> {

        return axios.put("/api/customer-data/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public getCustomers(filters: FindAllCustomersFilters): Promise<findAllCustomersResponseDTO> {
        return axios.get("/api/customer-data", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page,
                norm: filters.norm,
                companyName: filters.companyName,
                search: filters.search !== '' ? filters.search : undefined,
                order: filters.order,
                headQuarterIds: filters.headquarterId,
                active: filters.active,
                operatorsGroup: filters.operatorsGroup
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public getCustomerById(id: string): Promise<CustomerResponseDTO> {
        return axios.get("/api/customer-data/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public getCustomerByCode(code: string): Promise<FindAllCustomerByCodeResponseDTO> {
        return axios.get("/api/customer-data", {
            params: {
                page: 0,
                itemsPerPage: 0,
                clientCode: code
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}
